// extracted by mini-css-extract-plugin
module.exports = {"not-found":"NotFound_not-found__EyT33"};